import Vue from 'vue';
import api from '../../api/user'
import CONFIG from '@/constants/config.js';

const state = {
    app_locale: null,
    app_logged_in:false,
    app_identifier:null,
    app_user:{},
    app_user_id:null,
    app_user_last_logged_in_id:null,
    app_token:null,
    app_alias:null,
    app_session:null,
    app_loading:false,
    app_auth_error:false,
    app_history:0,
    // app settings block of appuser/getplayer (easy_event_selection, main_event_id, main_event_name, ...)
    app_settings:null,
}

// getters
const getters = {
    isLoggedIn:state=>{
        return state.app_logged_in && state.app_token;
    },
    mainEventId:state=>{
        let id=(state.app_settings)?parseInt(state.app_settings.main_event_id,10):NaN;
        return (isFinite(id) && id>0)?id:0;
    },
    mainEventName:state=>{
        return (state.app_settings && state.app_settings.main_event_name)?String(state.app_settings.main_event_name):'';
    },
    // unknown settings count as enabled, like the native default of EASY_EVENT_SELECT
    serverEasyEventSelection:state=>{
        if(!state.app_settings || typeof state.app_settings.easy_event_selection === 'undefined'){
            return true;
        }
        let value=state.app_settings.easy_event_selection;
        return value===true || value===1 || value==='1' || value==='true';
    },
    aliasUser:state=>{
        return (state.app_alias)?state.app_alias:state.app_user;
    },
    userId:state => {
        return state.app_user_id;
    },
    lastLoggedInUserId:state=>{
        return state.app_user_last_logged_in_id
    },
    isAdmin:state => {
        return (state.app_user)?(state.app_user.roles && Vue._.includes(state.app_user.roles,CONFIG.ROLE_ADMIN)):false
    },
    hasHistoryStack:state=>{
        return state.app_history>1;
    }
}

// actions
const actions = {

    login ({ commit },credentials) {
        commit('SET_APP_AUTH_ERROR', false);
        commit('SET_APP_LOADING', true);

        return new Promise((resolve, reject) => {
            api.login(credentials).then(response=>{
                let user=(response && response.data && response.data.person)?response.data.person:null;
                let token=(response && response.data)?response.data.token:null;
                let app_id=(response && response.data)?response.data.app_id:null;

                commit('SET_APP_ALIAS', null);
                commit('SET_APP_USER', user);
                commit('SET_APP_TOKEN', token);
                commit('SET_APP_LOGGED_IN', !Vue._.isEmpty(token));
                commit('SET_APP_IDENTIFIER', app_id);
                resolve(user);
            }).catch(error=>{
                commit('SET_APP_LOGGED_IN', false);
                commit('SET_APP_IDENTIFIER', null);
                commit('SET_APP_ALIAS', null);
                commit('SET_APP_USER', null);
                commit('SET_APP_TOKEN', null);
                commit('SET_APP_AUTH_ERROR', true);
                reject(error);
            }).finally(()=>{
                commit('SET_APP_LOADING', false);
            })
        })
    },
    loginWithQR ({ commit },qrData) {
        commit('SET_APP_AUTH_ERROR', false);
        commit('SET_APP_LOADING', true);

        return new Promise((resolve, reject) => {
            api.loginWithQR(qrData).then(response=>{
                let user=(response && response.data && response.data.person)?response.data.person:null;
                let token=(response && response.data)?response.data.token:null;
                let app_id=(response && response.data)?response.data.app_id:null;

                commit('SET_APP_ALIAS', null);
                commit('SET_APP_USER', user);
                commit('SET_APP_TOKEN', token);
                commit('SET_APP_LOGGED_IN', !Vue._.isEmpty(token));
                commit('SET_APP_IDENTIFIER', app_id);
                resolve(user);
            }).catch(error=>{
                commit('SET_APP_LOGGED_IN', false);
                commit('SET_APP_IDENTIFIER', null);
                commit('SET_APP_ALIAS', null);
                commit('SET_APP_USER', null);
                commit('SET_APP_TOKEN', null);
                commit('SET_APP_AUTH_ERROR', true);
                reject(error);
            }).finally(()=>{
                commit('SET_APP_LOADING', false);
            })
        })
    },

    getPerson({ commit }) {
        commit('SET_APP_LOADING', true);
        return new Promise((resolve, reject) => {
            api.getPlayer().then(response=>{
                commit('SET_APP_SETTINGS', (response && response.data && response.data.settings)?response.data.settings:null);
                resolve(response.data);
            }).catch(error=>{
                reject(error);
            }).finally(()=>{
                commit('SET_APP_LOADING', false);
            })
        });
    },

    getPlayer({ commit,state }) {
        return new Promise((resolve, reject) => {
            api.getPlayer({
                eventId:state.selected_event_id
            }).then(response=>{
                let user=(response && response.data && response.data.person)?response.data.person:null;
                let token=(response && response.data)?response.data.token:null;
                commit('SET_APP_USER', user);
                commit('SET_APP_TOKEN', token);
                commit('SET_APP_LOGGED_IN', !Vue._.isEmpty(token));
                commit('SET_APP_SETTINGS', (response && response.data && response.data.settings)?response.data.settings:null);
                resolve(response.data);
            }).catch(error=>{
                reject(error);
            }).finally(()=>{
            })
        })
    },

    logout ({ commit,state }) {
        commit('SET_APP_LOADING', true);
        return new Promise((resolve, reject) => {
            api.logout().then(response=>{
                resolve(response);
            }).catch(error=>{
                reject(error);
            }).finally(()=>{
                commit('SET_APP_LAST_USER_ID',state.app_user_id);
                commit('SET_APP_LOGGED_IN', false);
                commit('SET_APP_IDENTIFIER', null);
                commit('SET_APP_ALIAS', null);
                commit('SET_APP_USER', null);
                commit('SET_APP_TOKEN', null);
                commit('SET_APP_LOADING', false);
            })
        })
    },
    changePassword ({ commit },d) {
        commit('SET_APP_LOADING', true);
        return new Promise((resolve, reject) => {
            api.changePassword(d).then(response=>{
                resolve(response);
            }).catch(error=>{
                reject(error);
            }).finally(()=>{
                commit('SET_APP_LOADING', false);
            })
        })
    },

    requestPasswordChange ({ commit },email) {
        commit('SET_APP_LOADING', true);
        return new Promise((resolve, reject) => {
            api.changePassword({
                email:email
            }).then(response=>{
                resolve(response);
            }).catch(error=>{
                reject(error);
            }).finally(()=>{
                commit('SET_APP_LOADING', false);
            })
        })
    },
    //Requests user by id.
    getUserById ({ commit },id) {

        commit('SET_APP_LOADING', true);
        return new Promise((resolve, reject) => {
            if(null!=id){
                //Request server
                api.getUserById(id).then(response=>{
                    if(response && response.data){
                        resolve(response.data);
                    }else{
                        reject(null);
                    }
                }).catch(error=>{
                    reject(error);
                }).finally(()=>{
                    commit('SET_APP_LOADING', false);
                })
            }else{
                reject(null);
            }
        })
    },
    setAliasByUserId({ commit },id){
        return new Promise((resolve, reject) => {
            if(null==id){
                reject();
            }

            api.getUserById(id).then((response)=>{
                if(response && response.data){
                    commit('SET_APP_ALIAS', response.data);
                    resolve(response.data)
                }else{
                    commit('SET_APP_ALIAS', null);
                    reject();
                }
            }).catch((ex) => {
                commit('SET_APP_ALIAS', null);
                reject(ex);
            });
        });
    },
    updateUser ({ commit },data) {
        commit('SET_APP_LOADING', true);
        return new Promise((resolve, reject) => {
            api.updateUser(data).then(response=>{
                let data=(response && response.data)?response.data:null;
                commit('SET_ALIAS_OTHERWISE_APP_USER', data);
                resolve(response);
            }).catch(error=>{
                reject(error);
            }).finally(()=>{
                commit('SET_APP_LOADING', false);
            })
        })
    },
    register ({ commit },data) {
        commit('SET_APP_LOADING', true);

        return new Promise((resolve, reject) => {

            api.register(data).then(response=>{
                let data=(response && response.data)?response.data:null;
                commit('SET_APP_USER', data);
                resolve(data);
            }).catch(error=>{
                commit('SET_APP_USER', null);
                reject(error);
            }).finally(()=>{
                commit('SET_APP_LOADING', false);
            })
        })
    },
}

// mutations
const mutations = {
    SET_APP_LOCALE (state, payload) {
        state.app_locale = payload
    },
    SET_APP_LOGGED_IN (state, payload) {
        state.app_logged_in = payload
    },
    SET_APP_LAST_USER_ID(state,userId){
        if(null!=userId){
            Vue.set(state,'app_user_last_logged_in_id',userId);
        }
    },
    SET_APP_USER (state, user) {

        let userId=(user)?user.ID:null;
        Vue.set(state,'app_user_id',userId);
        Vue.set(state,'app_user',user);
    },

    SET_ALIAS_OTHERWISE_APP_USER (state, user) {
        if(state.app_alias){
            console.log('SET alias');
            Vue.set(state,'app_alias',user);
        }else{
            console.log('SET user');
            Vue.set(state,'app_user',user);
        }
    },
    SET_APP_ALIAS (state, user) {
        Vue.set(state,'app_alias',user);
    },
    SET_APP_TOKEN(state, token) {
        Vue.set(state,'app_token',token);
    },
    SET_APP_LOADING(state,val){
        Vue.set(state,'app_loading',val);
    },
    SET_APP_SESSION(state,val){
        Vue.set(state,'app_session',val);
    },

    SET_APP_AUTH_ERROR(state,val){
        Vue.set(state,'app_auth_error',val);
    },
    INCREMENT_APP_HISTORY(state){
        Vue.set(state,'app_history',++state.app_history)
    },

    //Update alias or own user
    UPDATE_APP_USER(state,{user,data}){
        if(!Vue._.isEmpty(user)){
            let newUserData=Vue._.merge(user,data);
            if(state.app_user && state.app_user.id == user.id){
                Vue.set(state,'app_user',newUserData);
            }else if(state.app_alias && state.app_alias.id == user.id){
                Vue.set(state,'app_alias',newUserData);
            }

        }
    },
    SET_APP_IDENTIFIER(state,stat){
        Vue.set(state,'app_identifier',stat);
    },
    // null leaves the last known settings untouched (a failed request must not forget the main event)
    SET_APP_SETTINGS(state,settings){
        if(settings && typeof settings === 'object'){
            Vue.set(state,'app_settings',settings);
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
